import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "px-4 py-4.5 border border-gray-200 shadow sm:rounded-lg h-52 overflow-auto" }
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col gap-y-5"
}
const _hoisted_3 = {
  key: 0,
  class: "text-gray-500 mb-4"
}

import { computed, ref, watch } from "vue"
import GgmsInput from "@/components/GgmsInput.vue"
import GgmsLoading from "@/components/GgmsLoading.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsChip from "@/components/GgmsChip.vue"
import { SearchIcon } from "@heroicons/vue/outline"
import { useGridCollectionStore } from "@/stores/grid-collection"
import { debounce, getNotFoundText } from "@/shared/utils/helpers"

interface Props {
    collectionsSelectedState: boolean[]
    hasFilterCollections: boolean
    typeName: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterCollection',
  props: {
    collectionsSelectedState: {},
    hasFilterCollections: { type: Boolean },
    typeName: {}
  },
  emits: ["onCollectionSelect"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const gridCollectionStore = useGridCollectionStore()
const collectionTableState = computed(() => gridCollectionStore.collectionTableState)

const localCollectionsSelectedState = ref<boolean[]>(props.collectionsSelectedState)

const collections = computed(() => collectionTableState.value.data)

function createFilterTag() {
    // get the selected collections ids which are selected in localCollectionsSelectedState
    const selectedCollectionsIds = [] as string[]
    localCollectionsSelectedState.value.forEach((selected, index) => {
        if (selected) {
            selectedCollectionsIds.push(collections.value[index]._id)
        }
    })

    emit("onCollectionSelect", selectedCollectionsIds)
}

watch(
    () => collectionTableState.value.search,
    debounce(() => {
        if (props.hasFilterCollections) {
            // this is to prevent the search from being triggered when the modal is closed
            return
        }
        collectionTableState.value.currentPage = 0
    }, 250)
)

watch(
    () => localCollectionsSelectedState.value,
    () => {
        createFilterTag()
    },
    { deep: true }
)

watch(
    () => props.collectionsSelectedState,
    () => {
        localCollectionsSelectedState.value = props.collectionsSelectedState
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GgmsInput, {
      modelValue: collectionTableState.value.search,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((collectionTableState.value.search) = $event)),
      placeholder: "Search values",
      iconStart: _unref(SearchIcon)
    }, null, 8, ["modelValue", "iconStart"]),
    _createElementVNode("div", _hoisted_1, [
      (collectionTableState.value.isLoading)
        ? (_openBlock(), _createBlock(GgmsLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collections.value, (collection, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: collection._id,
                class: "flex items-center gap-x-2"
              }, [
                _createVNode(GgmsCheckBox, {
                  modelValue: localCollectionsSelectedState.value[i],
                  "onUpdate:modelValue": ($event: any) => ((localCollectionsSelectedState.value[i]) = $event)
                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                _createVNode(GgmsChip, { isRemovable: false }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(collection.displayName), 1)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128)),
            (!collections.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_unref(getNotFoundText)("lists", collectionTableState.value.search)), 1))
              : _createCommentVNode("", true)
          ]))
    ])
  ], 64))
}
}

})